import { productSelectors } from '@ynap/product-state';

const { getProductImageFromTemplate, getProductVideoFromTemplate, getBadge, getProductAvailability } = productSelectors;

export const getSelectedProductColour = (productColours) => {
    const productColour = productColours?.find(({ selected }) => selected);
    if (!productColour) {
        return null;
    }
    return {
        ...productColour,
        sKUs: getSelectedProductSkus(productColour),
    };
};

export const getSelectedSize = (skus, selectedSku) => {
    if (skus.length === 1) {
        return skus[0];
    }
    const selectedSkuPartNumber = selectedSku && selectedSku.partNumber;
    const selectedSize = selectedSkuPartNumber ? skus.find(({ partNumber }) => selectedSkuPartNumber === partNumber) : skus.find(({ selected }) => selected);
    return selectedSize || {};
};

export const getSelectedProductImages = (product, selectedProductColour, availableImageSizes, imageQuality, zoomedImageQuality, imagesphereAspectRatio) => {
    const alt = product ? `${product.designerName || ''} ${product.shortDescription || product.name || ''}` : '';
    const { imageTemplate = '', imageViews = [] } = selectedProductColour;

    return imageViews.map((view) => {
        const { url, zoomUrl, srcSet, zoomSrcSet } = getProductImageFromTemplate(
            imageTemplate,
            view,
            availableImageSizes,
            imageQuality,
            zoomedImageQuality,
            imagesphereAspectRatio,
        );

        return {
            id: view,
            url,
            zoomUrl,
            srcSet,
            zoomSrcSet,
            alt,
        };
    });
};

export const getSelectedProductVideos = (selectedProductColour = {}, images = []) => {
    const { videoTemplate, videoViews } = selectedProductColour;
    const thumbnail = images.find((image) => image.id === 'ou') || images[0];

    if (videoTemplate && videoViews) {
        return selectedProductColour.videoViews.map((view) => {
            const { url } = getProductVideoFromTemplate(videoTemplate, view);

            return {
                id: view,
                thumbnail,
                url,
            };
        });
    }

    return [];
};

export const getSelectedProductBadges = (selectedProductColour = {}, selectedProductSize = {}, configSaleBadges, badgeBlocklist = [], user) => {
    const { onSale, badges } = selectedProductColour;

    const selectedProductColorFirstBadge = getBadge({
        badges,
        user,
        segmentBadges: selectedProductColour?.segmentBadges,
        badgeBlocklist,
        options: { onSale, configSaleBadges },
    });

    const selectedProductSizeBadge = selectedProductSize?.badges?.find((badge) => badge.type === 'STOCK');
    const areBadgesEqual = selectedProductColorFirstBadge?.key === selectedProductSizeBadge?.key;

    return {
        selectedProductColorFirstBadge,
        selectedProductSizeBadge: !areBadgesEqual ? selectedProductSizeBadge : null,
    };
};

export const getSelectedProductSkus = (selectedProduct) => {
    if (!selectedProduct.sKUs) {
        return [];
    }
    return selectedProduct.sKUs
        .filter((sku) => sku.displayable && !sku.banned)
        .map((sku, i, arr) => {
            sku.availability = getProductAvailability(sku);

            if (arr.length > 1) {
                return sku;
            }
            // TODO: TYS-991 remove once TON WCS product data has been cleaned and removes labelSize: '--'
            if (sku.size.labelSize === '--' || sku.size.labelSize === 'n/a') {
                return {
                    ...sku,
                    size: {
                        ...sku.size,
                        labelSize: '',
                    },
                };
            }
            return sku;
        });
};
